import { render, staticRenderFns } from "./VisitHistorySelection.vue?vue&type=template&id=112e08df&scoped=true&lang=pug&"
import script from "./VisitHistorySelection.vue?vue&type=script&lang=js&"
export * from "./VisitHistorySelection.vue?vue&type=script&lang=js&"
import style0 from "./VisitHistorySelection.vue?vue&type=style&index=0&id=112e08df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e08df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VCard,VDataTable,VDivider,VIcon,VImg,VSpacer,VTab,VTabs})
